const url = process.env.REACT_APP_SERVER_ADOBE_URL_BASE;

const adobeSignConfig = {
	baseURL: url + 'adobesign/',
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json',
	},
};
export default adobeSignConfig;